import {useForm} from 'react-hook-form';
import {toast} from 'react-toastify';
import {t} from '@lingui/core/macro';

import {tagsAPI} from 'entities/monitor';
import {serverAPI} from 'features/server/api/serverAPI';
import {buildServerPayload, getServerFormDefaults} from 'features/server/lib/serverFormHelper';

import CreateServerType from './Server/CreateServerType';
import IServerOutput from './Server/IServer';

interface IParams {
    item?: IServerOutput,
    // eslint-disable-next-line no-unused-vars
    onCreated: (server: IServerOutput) => void,
    onUpdated: () => void,
}

export const useServerForm = ({item, onCreated, onUpdated}: IParams) => {
    const [addServer, {isLoading: isLoadingCreate}] = serverAPI.useAddServerMutation();
    const [updateServer, {isLoading: isLoadingUpdate}] = serverAPI.useUpdateServerMutation();
    const {refetch: refetchTags} = tagsAPI.useGetTagsQuery();

    const isNew = !item;

    const form = useForm<CreateServerType>({
        mode: 'onChange',
        defaultValues: getServerFormDefaults(item),
    });

    const submit = form.handleSubmit(async(formData) => {
        const data = buildServerPayload(formData);

        try {
            if (isNew) {
                const created = await addServer(data).unwrap();
                await refetchTags();
                onCreated(created);
            } else {
                await updateServer({uuid: item.uuid, ...data}).unwrap();
                await refetchTags();
                toast.info(t`Сервер изменён`);
                onUpdated();
            }
        } catch (error) {
        }
    });

    return {form, submit, isNew, isLoading: isLoadingCreate || isLoadingUpdate};
};
